module.exports = __webpack_public_path__ + "img/DE06134.8aaff18e.png";